/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CatalogUpdateCatalogResponse } from "./CatalogUpdateCatalogResponse";

export type CatalogUpdateCatalogResponseApiRespoonse = {
  data?: CatalogUpdateCatalogResponse;
  status?: CatalogUpdateCatalogResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace CatalogUpdateCatalogResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
